var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgInstagramFooter(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_147_704)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M13.8777 20H6.12229C2.74698 20 0 17.253 0 13.8777V6.12229C0 2.74698 2.74698 0 6.12229 0H13.8751C17.2504 0 19.9974 2.74698 19.9974 6.12229V13.8751C19.9974 17.2504 17.2504 19.9974 13.8751 19.9974L13.8777 20ZM6.12229 1.49812C3.57263 1.49812 1.49812 3.57263 1.49812 6.12229V13.8751C1.49812 16.4248 3.57263 18.5019 6.12489 18.5019H13.8777C16.4274 18.5019 18.5045 16.4274 18.5045 13.8751V6.12229C18.5045 3.57263 16.43 1.49552 13.8777 1.49552H6.12229V1.49812Z",
    fill: "#FCF2FF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.9987 15.0591C7.21018 15.0591 4.94093 12.7898 4.94093 10.0013C4.94093 7.21279 7.21018 4.94354 9.9987 4.94354C12.7872 4.94354 15.0565 7.21279 15.0565 10.0013C15.0565 12.7898 12.7872 15.0591 9.9987 15.0591ZM9.9987 6.47541C8.05401 6.47541 6.4728 8.05662 6.4728 10.0013C6.4728 11.946 8.05401 13.5272 9.9987 13.5272C11.9434 13.5272 13.5246 11.946 13.5246 10.0013C13.5246 8.05662 11.9434 6.47541 9.9987 6.47541Z",
    fill: "#FCF2FF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.9259 4.3905C16.9259 5.11749 16.3365 5.70687 15.6095 5.70687C14.8825 5.70687 14.2931 5.11749 14.2931 4.3905C14.2931 3.66351 14.8825 3.07413 15.6095 3.07413C16.3365 3.07413 16.9259 3.66351 16.9259 4.3905Z",
    fill: "#FCF2FF"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_147_704"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInstagramFooter);
export default __webpack_public_path__ + "static/media/instagram-footer.687982d9b585d2f3240d12ab27fa7ab2.svg";
export { ForwardRef as ReactComponent };